import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTablePpcPortfolio from "dashboards/lite/LiteMetricTablePpcPortfolio";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';

export default function PpcPortfolioDashboard(props) {
  console.log(props)
  const clientInfo = props.client_info;
  // const ppcPortfolioDimensions = jsDig(["overall", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "spend"], props.table_data)).sort() : [];

  const newDimensions = clientInfo.map(({ company_name, alerts, goals, id }) => [company_name, alerts, goals, id]);
  let mainIcon = require("images/lite/icons/bar-separated.svg");
  mainIcon = <div className="overview-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>

  return (
    <>
      <div className="lite-dashboard other-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>PPC Portfolio Performance</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
        </div>
        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTablePpcPortfolio
                // headerOrder={["spend", "conversions", "cpa", "revenue", "roas", "mer"]}
                headerOrder={["spend", "conversions", "cpa", "roas"]}
                // subHeaderOrder={["MTD", "L7D", "L7D Avg.", "Yesterday", "Proj."]}
                subHeaderOrder={["MTD", "L7D", "Yesterday"]}
                data={
                  {
                    "overall": jsDig(["overall"], props.table_data),
                    "search": jsDig(["search"], props.table_data),
                    "social": jsDig(["social"], props.table_data),
                  }
                }
                tableName="PPC Portfolio Performance"
                clientInfo={props.client_info}
                dimensions={newDimensions}
                topSummaryRow={{dimension: "Total", data: jsDig(["top_summary_bar"], props.table_data)}}
                groups={["Overall", "Search", "Social"]}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
